export default __webpack_public_path__ + "static/media/sLSD.cd96f011.svg";